module.exports = __webpack_public_path__ + "img/title-rq.1a7d4d37.png";